var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import qs from 'qs';
import { withRouter } from 'react-router';
import { Trans, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { localizeUrl } from '../../../core/helpers/url-helper';
var AuthOptions = /** @class */ (function (_super) {
    __extends(AuthOptions, _super);
    function AuthOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthOptions.prototype.render = function () {
        var params = qs.parse(this.props.location.search.substr(1));
        return (React.createElement("div", { className: "c-registration-cta" },
            React.createElement("i", { className: "icon-info" }),
            React.createElement(Trans, { i18nKey: "auth.registration_cta.text" },
                React.createElement(Link, { to: localizeUrl("/auth/registration" + (params.checkout ? '?checkout=1' : '')) }))));
    };
    return AuthOptions;
}(React.Component));
export default withRouter(withTranslation()(AuthOptions));
